var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 33H31.5M8.4 12.57H6C5.175 12.57 4.5 13.245 4.5 14.07V27C4.5 27.825 5.175 28.5 6 28.5H8.4C9.225 28.5 9.9 27.825 9.9 27V14.07C9.9 13.245 9.225 12.57 8.4 12.57ZM19.2 7.785H16.8C15.975 7.785 15.3 8.46 15.3 9.285V27C15.3 27.825 15.975 28.5 16.8 28.5H19.2C20.025 28.5 20.7 27.825 20.7 27V9.285C20.7 8.46 20.025 7.785 19.2 7.785ZM30 3H27.6C26.775 3 26.1 3.675 26.1 4.5V27C26.1 27.825 26.775 28.5 27.6 28.5H30C30.825 28.5 31.5 27.825 31.5 27V4.5C31.5 3.675 30.825 3 30 3Z",
    stroke: "#C0C2C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.38b2ad6a54c0e09c439cb72ace289326.svg";
export { ForwardRef as ReactComponent };